import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  sideBar: {
    backgroundColor: 'white',
    minWidth: 256,
    border: 'solid 1px #dfdfe6'
  },
  itens: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 16,
    fontWeight: 500,
    color: '#5e6784',
    padding: '10px 18px',
    listStyle: 'none',
    margin: 0,
    cursor: 'pointer',
  },
  itensSelecionado: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 16,
    fontWeight: 500,
    padding: 10,
    color: '#0430ad',
    backgroundColor: '#edf4ff',
    width: '85%',
    borderTopRightRadius: 6,
    borderBottomRightRadius: 6,
    borderLeft: 'solid 8px #6ea6ff',
    boxSizing: 'border-box',
    listStyle: 'none',
    margin: 0,
    cursor: 'pointer',
  }
});

export default useStyles;
